<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("ourProducts") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <div class="text-right mb-2" v-if="canMoveProduct">
            <v-btn
              @click="openMoveProductDialog"
              :disabled="selectedItems.length === 0"
              color="primary"
            >
              {{ $t("moveProduct") }}
            </v-btn>
          </div>
          <table-with-filter
            fixed-headerg
            :headers="headersWithTranslate"
            :items="items"
            :options.sync="configuration.options"
            hide-default-footer
            @update:sort="getProductItemsBySort"
          >
            <template #filter.warehouseName>
              <!--              <vue-select-->
              <!--                clearable-->
              <!--                ref="warehouseSelectRef"-->
              <!--                infinite-->
              <!--                @input="getProductItemsByFilter"-->
              <!--                rules="required"-->
              <!--                @item-resolved="setWarehouse"-->
              <!--                @next-page-resolved="-->
              <!--                  (data) => setWarehouse([...warehouseList, ...data])-->
              <!--                "-->
              <!--                :get-item-promise="-->
              <!--                  ({ text, page }) =>-->
              <!--                    $store.dispatch('getWareHouses', {-->
              <!--                      page,-->
              <!--                      name: text,-->
              <!--                      limit: 15,-->
              <!--                    })-->
              <!--                "-->
              <!--                v-model="ourProductFilter.warehouseId"-->
              <!--                :items="warehouseList"-->
              <!--                class="product-select-in-modal"-->
              <!--              ></vue-select>-->
            </template>
            <template #filter.accountingCode>
              <CustomInputText
                clearable
                v-model="ourProductFilter.accountingCode"
                @input="getProductItemsByFilter"
                class="no-margin user_input"
              ></CustomInputText>
            </template>
            <template #filter.productTypeName>
              <div class="pa-1">
                <vue-select
                  infinite
                  clearable
                  @item-resolved="setProductType"
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getProductTypes', {
                        name: text,
                        limit: 15,
                        page,
                      })
                  "
                  @next-page-resolved="
                    (data) => setProductType([...productTypes, ...data])
                  "
                  :items="productTypes"
                  @input="getProductItemsByFilter"
                  v-model="ourProductFilter.productTypeId"
                />
              </div>
            </template>
            <template #filter.takenAwayUser v-if="canChangeMaterial">
              <vue-select
                @input="getProductItemsByFilter"
                infinite
                clearable
                @item-resolved="setUser"
                @next-page-resolved="(data) => setUser([...usersList, ...data])"
                :get-item-promise="
                  ({ text, page }) =>
                    $store.dispatch('getUsers', { page, name: text, limit: 15 })
                "
                v-model="ourProductFilter.takenAwayUserId"
                :items="usersList"
                class="product-select-in-modal"
              ></vue-select>
            </template>
            <template
              #item.contractCode="{
                /**
                 * @type Object
                 * @property toWarehouseApplicationInprogress {string}
                 */
                item,
              }"
            >
              <span></span>
              <v-checkbox
                v-if="
                  canChangeMaterial &&
                  !trueSet(item.toWarehouseApplicationInprogress)
                "
                multiple
                :value="item.id"
                v-model="selectedItems"
                hide-details
                dense
                class="mt-0"
              ></v-checkbox>
            </template>
            <template #filter.productName>
              <div class="pa-1">
                <vue-select
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getProducts', {
                        name: text,
                        page,
                        limit: 15,
                      })
                  "
                  @item-resolved="setProduct"
                  @next-page-resolved="
                    (data) => setProduct([...products, ...data])
                  "
                  :items="products"
                  v-model="ourProductFilter.productId"
                  @input="getProductItemsByFilter"
                  clearable
                  infinite
                  name="select_on_block"
                >
                  <template #option="{ item, searchText }">
                    <product-select-item
                      :name="item.name"
                      :attrs="item.attrs"
                      :search-text="searchText"
                    ></product-select-item>
                    <v-list-item-title>
                      <p class="ma-0">{{ item.name }}</p>
                      <span class="v-messages">{{
                        item.attrs.join(" && ")
                      }}</span>
                    </v-list-item-title>
                  </template>
                </vue-select>
              </div>
            </template>
            <template #item.action="{ item }">
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click="$refs.writeOffProductDialog.open(item.id)"
                    class="new_style"
                  >
                    <vue-icon icon="newTaskListIcon"></vue-icon>
                  </v-btn>
                </template>
                {{ $t("writeOffProduct") }}
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="{
                      name: 'product-history',
                      query: { qrCode: item.id },
                    }"
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                  >
                    <vue-icon icon="newTimeIcon"></vue-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("productHistory", 1) }}</span>
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="printQr(item)"
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                  >
                    <vue-icon icon="newPrintIcon"></vue-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("printQrCode", 1) }}</span>
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="$refs.divisionProductEditDialog.open(item)"
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                  >
                    <vue-icon icon="newPencilIcon"></vue-icon>
                  </v-btn>
                </template>
                <span>{{ $t("envNumber") }}</span>
              </v-tooltip>
            </template>
            <template #item.productName="{ item }">
              <div>
                <p class="mb-1">
                  {{ item.productName }} (qrcode: {{ item.qrcode }})
                </p>
                <p
                  class="error--text mb-0"
                  v-if="trueSet(item.toWarehouseApplicationInprogress)"
                >
                  {{ $t("movedToWarehouseAndInProgress") }}
                </p>
                <div class="mt-2">
                  {{ $t("attributes") }}: {{ item.productAttrs.join(" || ") }}
                </div>
              </div>
            </template>
            <template
              #item.orderedDepartmentsName="{
                /**
                 * @type Object
                 * @property orderedDepartmentsName {string}
                 */
                item,
              }"
            >
              {{
                item.orderedDepartmentsName &&
                item.orderedDepartmentsName.join(", ")
              }}
            </template>
            <template #item.count="{ item }"
              >{{ item.count | numberParse }}
              {{ item[`unit_type_name_${$i18n.locale}`] }}
            </template>
            <template
              #item.receiverDate="{
                /**
                 * @type Object
                 * @property contractItemAcceptedDate {string}
                 */
                item,
              }"
              >{{ item.contractItemAcceptedDate | dateParse }}</template
            >
            <template
              #item.takenAwayUser="{
                /**
                 * @type Object
                 * @property takenAwayDate {string}
                 * @property takenAwayUser {string}
                 * @property givenUser {string}
                 */
                item,
              }"
            >
              <div style="white-space: nowrap">
                <div>{{ $t("acceptUser") }}: {{ item.takenAwayUser }}</div>
                <div class="mt-2">
                  {{ $t("dateAcceptance") }}:
                  {{ item.takenAwayDate | fullTimeParse }}
                </div>
                <div class="mt-2">
                  {{ $t("gaveUser") }}: {{ item.givenUser }}
                </div>
              </div>
            </template>
            <template #item.print="{ item }">
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="printQr(item)"
                  >
                    <vue-icon icon="newPrintIcon"></vue-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("printQrCode", 1) }}</span>
              </v-tooltip>
            </template>
          </table-with-filter>
        </div>
        <vue-pagination
          @update:limit="
            (limit) => {
              configuration.pagination.limit = limit;
              configuration.pagination.page = 1;
              changePage();
            }
          "
          v-model="configuration.pagination.page"
          :length="lastPage"
          @input="changePage"
          go-to
          :limit="configuration.pagination.limit"
        />
      </div>
    </div>
    <write-off-product-dialog
      @saved="getProductItemsByFilter"
      ref="writeOffProductDialog"
    />
    <division-product-edit-dialog
      @CHANGED="getProductItemsByFilter"
      ref="divisionProductEditDialog"
    ></division-product-edit-dialog>
    <product-move-to-other-department
      @UPDATED="onUpdated"
      :selectedItemsNumber="selectedItems.length"
      ref="productMoveToOtherDepartment"
    ></product-move-to-other-department>
  </div>
</template>

<script>
import { makerPagination, trueSet } from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import { QrService } from "@/utils/QrService";
import { LotTemplate } from "@/utils/qr-template/LotTemplate";
import WriteOffProductDialog from "@/components/division/WriteOffProductDialog";
import { ADDITIONAL_ROLES, PRODUCT_ITEM_STATUS } from "@/utils/constants";
import DivisionProductEditDialog from "@/components/division/DivisionProductEditDialog.vue";
import ProductMoveToOtherDepartment from "@/components/product/ProductMoveToOtherDepartment.vue";
import ProductSelectItem from "@/components/product/SelectItem.vue";

export default {
  name: "division-products",
  data() {
    return {
      warehouseList: [],
      usersList: [],
      selectedItems: [],
      products: [],
      isShowFilter: false,
      ourProductFilter: {
        accountingCode: null,
        productTypeId: null,
        productId: null,
        orderNumb: null,
        contractNumb: null,
        takenAwayUserId: null,
        warehouseId: null,
        orderedDepartmentId: null,
      },
      productTypes: [],
      configuration: {
        pagination: {
          page: 1,
          limit: "10",
        },
        options: {
          sortBy: "takenAwayDate",
          sortDirection: false,
        },
      },
      lastPage: 0,
      items: [],
      headers: [
        { text: "product", value: "productName" },
        { text: "productGroup", value: "productTypeName" },
        { text: "productCode", value: "accountingCode" },
        { text: "count", value: "count" },
        { text: "warehouse", value: "warehouseName" },
        { text: "accepted", value: "takenAwayUser" },
        { text: "ENV", value: "invNumber" },
        { text: "action", value: "action" },
      ],
    };
  },
  computed: {
    canChangeMaterial() {
      return this.$store.getters.additionalRoles.includes(
        ADDITIONAL_ROLES.SEE_ALL_PRODUCTS_IN_WAREHOUSE
      );
    },
    canMoveProduct() {
      return this.$can(this.$permissions["SEE_ALL_PRODUCTS_IN_WAREHOUSE"]);
    },
    headersWithTranslate() {
      return this.headers.map((item) => {
        return {
          text: this.$t(item.text),
          value: item.value,
        };
      });
    },
  },
  methods: {
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    setWarehouse(warehouses) {
      this.warehouseList = warehouses;
    },
    setProduct(products) {
      this.products = products;
    },
    setUser(users) {
      this.usersList = users;
    },
    trueSet,
    openMoveProductDialog() {
      const items = [];
      this.selectedItems.forEach((id) => {
        const product = this.items.find((item) => item.id === id);
        if (product) items.push(product);
      });
      this.$refs.productMoveToOtherDepartment.open(items);
    },
    onUpdated() {
      this.getProductItemsByFilter();
      this.selectedItems = [];
    },
    /**
     * @typedef lotItem
     * @property {number} qrcode
     * @property {number} contractCode
     * @property {number} id
     * @param item {lotItem}
     * @returns {Promise<void>}
     */
    async printQr(item) {
      const qrService = new QrService();
      const qrTemplate = new LotTemplate();
      await qrTemplate.addQr(`{id: ${item.id}}`);
      qrTemplate.addText(`Id: ${item.qrcode}`);
      qrTemplate.addText(`Contract: ${item.contractCode}`);
      if (item.invNumber) {
        qrTemplate.addText(`Env: ${item.invNumber}`);
      }
      qrService.add(qrTemplate.data);
      qrService.show(item.name + "_qr");
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.push({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getProductItems();
        this.clearLoading();
      }
    },
    async getProductItemsByFilter() {
      if (this.ready) {
        this.showLoading();
        const { page } = this.configuration.pagination;
        if (page !== 1) {
          this.configuration.pagination.page = 1;
          await this.$router.push({ query: { page: `1` } });
        }
        await this.getProductItems();
        this.clearLoading();
      }
    },
    async getProductItemsBySort() {
      this.showLoading();
      const { query: initialQuery } = this.$route;
      const query = {
        ...initialQuery,
        ...this.configuration.pagination,
        ...this.configuration.options,
      };
      try {
        await this.$router.push({ query });
      } catch (e) {
        console.error(e);
      }
      await this.getProductItems();
      this.clearLoading();
    },
    async getProductItems() {
      this.selectedItems = [];
      const { page, limit } = this.configuration.pagination;
      let params = {
        ...this.ourProductFilter,
        ...this.configuration.options,
        page: page - 1,
        limit,
        idSort: true,
        state: PRODUCT_ITEM_STATUS.PRODUCT_PRODUCED,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get("product-item/own-product", {
          params,
        });
        this.items = data;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async created() {
    if (this.canMoveProduct) {
      this.headers.unshift({ value: "contractCode", text: "" });
    }
    this.showLoading();
    try {
      const { page, sortBy, sortDesc } = this.$route.query;
      if (page) this.configuration.pagination.page = +page;
      if (sortBy) this.configuration.options.sortBy = sortBy;
      if (typeof sortDesc !== "undefined")
        this.configuration.options.sortDesc = trueSet(sortDesc);
      await this.getProductItems();
      this.ready = true;
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
  components: {
    ProductSelectItem,
    ProductMoveToOtherDepartment,
    DivisionProductEditDialog,
    WriteOffProductDialog,
    VuePagination,
    VueSelect,
    TableWithFilter,
  },
};
</script>
